<template>
  <div>
    <!-- 新增按钮 -->

    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
      :options="options3"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
import { getCensusData } from "../../api/user";

export default {
  components: {},
  data() {
    return {
      selUser: {},
      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      isfengjin: false,

      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      lianxu: "",
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "日期",
          key: "createtime",
        },
        {
          title: "能量总余额",
          key: "totalIntegral",
        },
        {
          title: "分解获得能量",
          key: "split_get_integral",
        },
        {
          title: "游戏获得能量",
          key: "game_get_integral",
        },
        {
          title: "营业赠送能量",
          key: "sys_get_integral",
        },
        {
          title: "商城退回增加能量",
          key: "shop_return_integral",
        },
        {
          title: "营业扣除能量",
          key: "sys_del_integral",
        },
        {
          title: "商城兑换消耗能量",
          key: "totalExchangeIntegral",
        },
        {
          title: "虚拟人物兑换消耗能量",
          key: "virtualExchangeIntegral",
        },
        {title: '换币消耗能量',key: 'power_del_coin',},
        {
          title: "赏袋总和",
          key: "totalRewardBags",
        },
      ],

      current: 1,
      total: 0,
      options3: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 将时间设置为当天的开始
          return date && date.getTime() > today.getTime() - 1;
        },
      },
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    close() {
      this.visible = false;
    },
    // disabledDate(date) {
    //   // 禁止选择今天及以后的日期

    // },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      getCensusData(params)
        .then((response) => {
          this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.totalPages; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        starttime,
        endtime,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
  },
};
</script>
